import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  showingText: { fontSize: 12, fontWeight: 400, color: 'black' },
});
